export * from './human-authorities.enum';



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/enums/index.ts